import React, { useMemo, useState } from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import { useReactiveVar } from '@apollo/client';
import { paymentMethodVar, subscriptionInfoPopupTransitionVar, subscriptionTypeVar } from 'app/apollo/reaction';
import Checkbox from 'app/components/Form/Checkbox2';
import Dots from 'assets/svg/dots.svg';
import { useToggleSubscription } from 'app/hooks/useToggleSubscription';

import { locales } from './subscriptionSwitch.locales';

import './subscription-switch.scss';


export default function SubscriptionSwitch(props) {
    const {
        locale,
    } = props;

    const { text, info } = locales[locale];
    const [toggleSubscription] = useToggleSubscription();
    const subscriptionType = useReactiveVar(subscriptionTypeVar);
    const [initialMethod] = useState(paymentMethodVar());
    const [lockToggle, setLockToggle] = useState(false);

    const [
        isChecked,
        setIsChecked,
    ] = useState(subscriptionType === 'subscription');

    const toggleSubscriptionType = (event) => {
        const nextType = event.target.checked ? 'subscription' : 'singlePay';
        const nextMethod = event.target.checked ? 'recurrent' : initialMethod;
        setLockToggle(true);
        toggleSubscription(nextType, nextMethod);
        setIsChecked(event.target.checked);
        setTimeout(() => { setLockToggle(false); }, 800);
    };

    const isCheckedState = useMemo(
        () => subscriptionType === 'subscription',
        [subscriptionType],
    );

    return (
        <>
            <div styleName="discount--wrap" data-test-id="discount--wrap">
                <div>
                    <Checkbox
                        name="subscription-filter"
                        id="subscription-filter"
                        onChange={toggleSubscriptionType}
                        checked={isCheckedState}
                        ariaLabel="Оформить подписку"
                        disabled={lockToggle}
                    />
                </div>
                <button
                    type="button"
                    onClick={toggleSubscriptionType}
                    styleName="discount__text--wrap"
                    disabled
                >
                    <div styleName="discount__number">
                        <span styleName="discount__number-value">- 10</span>
                        %
                    </div>
                    <div styleName="discount__text">
                        {text}
                    </div>
                </button>
            </div>
            <div styleName="discount__open-info-wrap">
                <button
                    styleName="discount__open-info"
                    type="button"
                    onClick={() => { subscriptionInfoPopupTransitionVar('entered'); }}
                >
                    <div styleName="discount__open-info-text">
                        {info}
                    </div>
                    <Dots styleName="dots" />
                </button>

            </div>
        </>
    );
}

SubscriptionSwitch.propTypes = {
    isSubscriptionActivated: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
};
